import React from "react";
import AppInfoStore from "./appInfo";
import RecentChangesStore from "./recentChanges";
import ClientPageStore from "./clientPageStore";
import NotificationStore from "./notificationStore";
import MarketDetailsStore from "./MarketDetailStore";
import ErrorStore from "./errorStore";
import HomePageStore from "./HomePageStore";
var RootStore = /** @class */ (function () {
    function RootStore() {
        Object.defineProperty(this, "AppInfoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "RecentChangesStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ClientPageStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "notificationStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "MarketDetailsStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "errorStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "HomePageStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.AppInfoStore = new AppInfoStore();
        this.RecentChangesStore = new RecentChangesStore();
        this.ClientPageStore = new ClientPageStore();
        this.notificationStore = new NotificationStore();
        this.MarketDetailsStore = new MarketDetailsStore();
        this.errorStore = new ErrorStore();
        this.HomePageStore = new HomePageStore();
    }
    return RootStore;
}());
var rootStore = new RootStore();
export var RootStoreContext = React.createContext(rootStore);
export var useAppInfoStore = function () { return React.useContext(RootStoreContext).AppInfoStore; };
export var useRecentChangesStore = function () { return React.useContext(RootStoreContext).RecentChangesStore; };
export var useClientPageStore = function () { return React.useContext(RootStoreContext).ClientPageStore; };
export var useNotificationStore = function () { return React.useContext(RootStoreContext).notificationStore; };
export var useMarketDetailsStore = function () { return React.useContext(RootStoreContext).MarketDetailsStore; };
export var useErrorStore = function () { return React.useContext(RootStoreContext).errorStore; };
export var useHomeStore = function () { return React.useContext(RootStoreContext).HomePageStore; };
export default rootStore;
